import $ from 'jquery';
import 'bootstrap';
import Backbone from 'backbone';
import dustjs from 'dustjs';
import 'jquery.scrollto';
import ProjectFormView from 'common/project_form';
import { ShoppingListSelectorProjectView } from './shopping_list_selector_project';
import ShoppingListSelectorModel from 'src/app/models/store/client/projects/shopping_list_selector';
import _shoppingListSelectorDust from 'store/global/common/projects/shopping_list_selector/_shopping_list_selector.dust';
import shoppingListSelectorDropdownDust from 'store/global/common/projects/shopping_list_selector/shopping_list_selector_dropdown.dust';
import 'store/global/common/projects/shopping_list_selector/_shopping_list_selector_group.dust';
import 'common/_modal.dust';
import { RenderMethods } from 'views/store/common/utility/view/view';
import { ProjectChecklistsModel } from 'models/store/client/projects/roomchecklists/project_checklists';
import { ProjectChecklistsCreateModal } from 'views/store/pages/account/projects/roomchecklists/create_modal';
import { StatusGet } from 'store/pages/account/projects/common/status/project_status';

export const ShoppingListSelectorView = Backbone.View.extend({
	events: {
		'click .js-new-project-button': 'handleNewProjectButton',
		'click .js-more-projects': 'loadMoreProjects',
		'click .js-search-projects-button': 'showSearchBar',
		'keyup .js-project-search-input': 'handleProjectSearchKeyPress',
		'click .js-project-search-button': 'handleProjectSearchButtonPress',
		'click .js-create-new-project-button': 'handleCreateNewProjectButton'
	},

	initialize: function(options = {}) {
		this.childViews = [];
		this.projects = [];
		this.shouldAppendRenderContent = false;
		this.hideGroups = options.hideGroups;
		this.renderContainer();

		this.listenTo(Backbone, 'project:saved', this.handleProjectCreated);
	},
	renderContainer() {
		dustjs.render(
			shoppingListSelectorDropdownDust,
			{ isProjectsRoomChecklists: window.dataLayer.model.isProjectsRoomChecklists },
			(err, out) => {
				if (err) {
					window.clientErrorHandler(err);
				}
				this.setElement(out);
				this.cacheStaticSelectors();
				this.cacheDynamicSelectors();

				this._createNewProjectModalView();
				this.fetchAndRender();
			}
		);
	},
	cacheStaticSelectors() {
		this.$contentContainer = this.$el.find('.js-add-to-project-dropdown-content');
		this.$moreProjectsButton = this.$el.find('.js-more-projects');
		this.$bottomBarButtons = this.$el.find('.js-bottom-bar-buttons');
		this.$projectSearchBar = this.$el.find('.js-project-search-bar');
		this.$projectSearchBarInput = this.$el.find('.js-project-search-input');
		this.$selector = this.$el.find('.js-shopping-list-selector');
		this.$newProjectModal = $('.js-modal-new-project');
	},
	cacheDynamicSelectors() {
		this.$collapseToggle = this.$el.find('.js-collapse-toggle');
	},
	_createNewProjectModalView() {
		if (this._isProjectsRoomChecklistsActive()) {
			this.projectChecklistCreateModal = new ProjectChecklistsCreateModal({
				_method: RenderMethods.prependTo,
				_targetEl: this._targetModal.bind(this),
				model: new ProjectChecklistsModel({ shouldRedirect: false }),
				el: this.$el.find('.js-modal-new-room-checklists')
			})
				.on(ProjectChecklistsCreateModal.events.hide, this._onProjectChecklistsCreateModalHidden, this)
				.render();
		} else {
			this.projectFormView = new ProjectFormView({
				el: this.$newProjectModal.find('.modal-body')
			});
		}
	},
	_isProjectsRoomChecklistsActive() {
		return window.dataLayer.model && window.dataLayer.model.isProjectsRoomChecklists;
	},
	_targetModal() {
		return this.$el.find('.js-modal-new-room-checklists .modal-body');
	},
	_onProjectChecklistsCreateModalHidden() {
		this.projectChecklistCreateModal.reset();
		return this;
	},
	fetchAndRender: function() {
		this.setLoading().createModels();
		this.searchModel.save(this.searchParamsModel.toJSON()).then((response) => {
			this.searchResultsModel.set(response);
			this.render();
		});
		return this;
	},
	createModels: function() {
		if (!this.searchParamsModel) {
			this.searchParamsModel = new Backbone.Model({
				searchTerm: '',
				page: 1
			});
		}
		if (!this.searchResultsModel) {
			this.searchResultsModel = new Backbone.Model();
		}
		if (!this.searchModel) {
			this.searchModel = new ShoppingListSelectorModel();
		}
		return this;
	},
	handleMoreProjectsButton: function() {
		const pageData = this.searchResultsModel.get('paging') || {},
			hasMorePages = pageData.page < pageData.pages;
		this.$moreProjectsButton.toggleClass('dn', !hasMorePages);
		return this;
	},
	render: function() {
		const resultsData = this.searchResultsModel.toJSON();
		dustjs.render(_shoppingListSelectorDust, { ...resultsData, hideGroups: this.hideGroups }, (err, out) => {
			if (err) {
				window.clientErrorHandler(err);
			}
			if (this.shouldAppendRenderContent) {
				this.$contentContainer.append(out);
				this.shouldAppendRenderContent = false;
			} else {
				this.$contentContainer.html(out);
			}
			this.createChildViews(resultsData.data).doneLoading();
			this.cacheDynamicSelectors();
			if (this.hideGroups) {
				this.hideGroupToggle();
			}
			if (resultsData) {
				this.showCreateProject(resultsData);
			}
			this.handleMoreProjectsButton();
		});
	},
	createChildViews: function(data = []) {
		if (!this.shouldAppendRenderContent) {
			this.childViews.forEach((view) => {
				view.undelegateEvents();
				view.$el.removeData().unbind();
				view.remove();
				Backbone.View.prototype.remove.call(view);
			});
		}
		this.childViews = this.childViews.concat(
			data.map((project) => {
				return new ShoppingListSelectorProjectView({
					model: new Backbone.Model(project),
					el: this.$contentContainer.find(`.js-project-${project.project.id}`),
					parentView: this
				});
			})
		);
		return this;
	},
	loadMoreProjects: function() {
		const currentPage = this.searchParamsModel.get('page'),
			resultsPaging = this.searchResultsModel.get('paging'),
			pages = resultsPaging.pages;
		if (currentPage < pages) {
			this.searchParamsModel.set({
				page: currentPage + 1
			});
			this.shouldAppendRenderContent = true;
			this.fetchAndRender();
		}
		return this;
	},
	show: function() {
		const shoppingLists = this.searchResultsModel.get('data') || [];
		if (!shoppingLists.length) {
			Backbone.trigger('omniture:projects', 'shopping_list_selector', 'show_no_projects');
			this._isProjectsRoomChecklistsActive() ? this.showCreateProjectChecklistModal() : this.showCreateProjectModal();
			return this;
		}
		Backbone.trigger('omniture:projects', 'shopping_list_selector', 'show_has_projects');
		this.$selector.removeClass('dn');
		return this;
	},
	showCreateProject: function(result) {
		const $searchButton = this.$projectSearchBar.find('.js-project-search-button');
		const $createButton = this.$projectSearchBar.find('.js-create-new-project-button');
		if (!result.data.length) {
			$searchButton.addClass('hide');
			$createButton.removeClass('hide');
		} else {
			$createButton.addClass('hide');
			$searchButton.removeClass('hide');
		}
		return this;
	},
	handleNewProjectButton: function() {
		if (this._isProjectsRoomChecklistsActive()) {
			this.showCreateProjectChecklistModal();
		} else {
			this.showCreateProjectModal();
		}
		Backbone.trigger('omniture:projects', 'shopping_list_selector', 'new_project_button');
	},
	handleCreateNewProjectButton: function() {
		StatusGet().show('createProject');
		const projectName = this.$projectSearchBarInput.val();
		this.projectChecklistsModel = new ProjectChecklistsModel({ projectName, shouldRedirect: false });
		this.projectChecklistsModel.createProject(this.onSuccess.bind(this), this.onError.bind(this));
	},
	onSuccess: function() {
		StatusGet().hide('createProject');
	},
	onError: function(model, error) {
		StatusGet().hide('createProject');
		StatusGet().handleError('createProject', { error, autoHide: true });
	},
	showCreateProjectChecklistModal: function() {
		this.projectChecklistCreateModal.show();
	},
	showCreateProjectModal: function() {
		this.hide();
		if (this.projectFormView) {
			this.projectFormView.reset();
			this.$newProjectModal.modal('show');
		}
		return this;
	},
	closeCreateProjectModal: function() {
		this.hide();
		if (this.projectFormView) {
			this.projectFormView.reset();
			this.$newProjectModal.modal('hide');
		}
		if (this._isProjectsRoomChecklistsActive()) {
			this.projectChecklistCreateModal.hide();
		}
		return this;
	},
	hide: function() {
		this.$selector.addClass('dn');
		this.hideSearchBar();
		return this;
	},
	reset: function() {
		this.hide()
			.resetSearchParams()
			.fetchAndRender();
	},
	isVisible: function() {
		return !this.$selector.hasClass('dn');
	},
	setLoading: function() {
		this.$selector.addClass('is-loading');
		return this;
	},
	doneLoading: function() {
		this.$selector.removeClass('is-loading');
		return this;
	},
	respond: function(payload) {
		this.trigger('listSelected', payload);
		Backbone.trigger('omniture:projects', 'shopping_list_selector', 'product_saved_to_project');
		this.reset();
	},
	resetSearchParams: function() {
		this.searchParamsModel.set({
			searchTerm: '',
			page: 1
		});
		return this;
	},
	handleProjectCreated: function(payload) {
		this.closeCreateProjectModal().createNamelessGroup(payload);
		Backbone.trigger('omniture:projects', 'shopping_list_selector', 'new_project_created');
		return this;
	},
	createNamelessGroup: function(project) {
		$.ajax({
			type: 'GET',
			url: `/app/api/shoppinglists/v2/${project.id}/defaultGroup`,
			cache: false
		}).then((groupData) => {
			this.respond({
				id: project.id,
				name: project.name,
				selectedGroup: {
					name: groupData.name,
					sessionCartId: groupData.cartId
				}
			});
		});
		return this;
	},
	showSearchBar: function() {
		this.$bottomBarButtons.addClass('dn');
		this.$projectSearchBar.removeClass('dn').addClass('flex');
		this.$projectSearchBarInput.focus();
		return this;
	},
	hideSearchBar: function() {
		this.$bottomBarButtons.removeClass('dn');
		this.$projectSearchBar.addClass('dn').removeClass('flex');
		return this;
	},
	hideGroupToggle: function() {
		this.$collapseToggle.addClass('dn');
		return this;
	},
	showGroupToggle: function() {
		this.$collapseToggle.removeClass('dn');
		return this;
	},
	handleProjectSearchKeyPress: function(e) {
		if (this.inputTimeout) {
			clearTimeout(this.inputTimeout);
		}
		if (e.key === 'Enter') {
			this.searchForProject();
			return this;
		}
		if (e.key === 'Escape' || e.key === 'Esc') {
			this.hideSearchBar();
			return this;
		}
		this.inputTimeout = setTimeout(this.searchForProject.bind(this), 500);
		return this;
	},
	handleProjectSearchButtonPress: function() {
		if (this.inputTimeout) {
			clearTimeout(this.inputTimeout);
		}
		this.searchForProject();
	},
	searchForProject: function() {
		this.searchParamsModel.set({
			searchTerm: this.$projectSearchBarInput.val(),
			page: 1
		});
		this.fetchAndRender();
		return this;
	},
	appendTo(view) {
		this.$el.appendTo(view.$el.find('.js-shopping-list-selector-wrapper'));
		return this;
	}
});
